import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '../styles';
export const MerchandiseComponent = ({ merchandise, tracker }) => {
    const onClick = () => {
        tracker.trackClickMerchandise(merchandise.id);
    };
    return (React.createElement("a", { className: css(styles.container), href: merchandise.url, target: "_blank", onClick: onClick },
        React.createElement("div", { className: css(styles.imageWrapper) },
            React.createElement("img", { className: css(styles.image), src: merchandise.imageUrl })),
        React.createElement("div", { className: css(styles.title) }, merchandise.title)));
};
const styles = StyleSheet.create({
    container: {
        color: Colors.Black,
        width: 'calc(50% - 5px)',
        [MediaBreakPointUp.MD]: {
            width: 'calc(33.3% - 7px)',
        },
        [MediaBreakPointUp.XL]: {
            width: 'calc(16.6% - 8px)',
        },
    },
    imageWrapper: {
        position: 'relative',
        width: '100%',
        paddingTop: '100%',
        border: `1px solid ${Colors.BorderLightGray}`,
        borderRadius: 4,
        marginBottom: 8,
        overflow: 'hidden',
    },
    image: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    title: {
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '140%',
        textDecoration: 'underline',
    },
});
